export const SAUCE_WINGS = [
  { 
    id: 1,
    name: "Hot Sauce",
    price: 0.75,
  },
  { 
    id: 2,
    name: "Medium Sauce",
    price: 0.75,
  },
  {  
    id: 3,
    name: "Mild Sauce",
    price: 0.75,
  },
  { 
    id: 4,
    name: "Honey Hot",
    price: 0.75,
  },
  { 
    id: 5,
    name: "BBQ",
    price: 0.75,
  },
  { 
    id: 6,
    name: "Honey BBQ",
    price: 0.75,
  }, 
];